import React from "react";

import logo from "../../images/logo-pieces-auto.png";

import {Logo as LogoContent, LogoText, LogoImage} from './style';

export default function Logo(props) {
  return (
    <LogoContent {...props}>
      <LogoText {...props}>
        Un jeu créé par<br /> PIÈCES&nbsp;AUTO
      </LogoText>
      <LogoImage src={logo} alt="Logo Pièces Auto" width="370" height="360" />
    </LogoContent>
  );
}



// WEBPACK FOOTER //
// ./src/components/Logo/index.js